import * as zoid from "@krakenjs/zoid/dist/zoid.frameworks.js";

export const CustomProductEditor = zoid.create({
  tag: "custom-product-editor",
  url: `${SERVER_URL}/custom-product-editor`,
  dimensions: {
    width: "100%",
    height: "100%",
  },
  exports: ({ getExports }) => {
    return {
      addImage: (imageUrl: string) =>
        getExports().then((exports) => exports.addImage(imageUrl)),
      // addText: (text: string) =>
      //   getExports().then((exports) => exports.addText(text)),
    };
  },
});
